import React from "react";
import TimeAgo from "react-timeago";

const RecentSearchList = ({ searchData }) => (
<div className="p-4 shadow rounded-4">
    <div className="d-flex justify-content-between mb-4 border-bottom pb-3">
    <strong>Recent search</strong>
    <span className="text-muted">
        <i className="bi bi-three-dots-vertical"></i>
    </span>
    </div>
    <ul className="list-unstyled w-full">
    {searchData && searchData.length > 0 &&
        searchData.map((search, index) => (
        <li
            className="mb-2 d-flex justify-content-start align-items-center w-full"
            key={index}
        >
            <div className="mb-1">
            <span className="me-2 small">{search.search_query}</span>
            <span className="me-2 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                <i className="bi bi-list-task me-1"></i>
                <span className="small">{search.results_count}</span>
            </span>
            <span className="me-2 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                <i className="bi bi-clock me-1"></i>
                <span className="small">
                <TimeAgo date={search.timestamp} />
                </span>
            </span>
            </div>
        </li>
        ))}
    </ul>
</div>
);

export default RecentSearchList;
